import { TCHOP_ROOT_URL } from '../../env';
import { prepareHeaders } from '../../services';
import { getOrganisationDomain } from './getOrganisationDomain';

export const isMediaParsed = (externalId?: string) => {
  if (!externalId) {
    return;
  }

  return new Promise<void>((resolve, reject) => {
    const getAssemblyInterval = setInterval(async () => {
      const { status } = await fetch(
        `${TCHOP_ROOT_URL}/api/fs/assembly/${externalId}/status?organisation=${getOrganisationDomain()}`,
        { credentials: 'include', headers: prepareHeaders(new Headers()) }
      ).then((result) => result.json());

      if (status === 'error') {
        clearInterval(getAssemblyInterval);
        reject();
      }

      if (status === 'ok') {
        clearInterval(getAssemblyInterval);
        resolve();
      }
    }, 1500);
  });
};
